// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"folderOptions_dropdownMenu__sfw3r"};